module.exports = __webpack_public_path__ + "nc_static/media/file-xls.0a5145ac.svg";